import { EventEmitter, EventSubscribeable, eventObject, AnyFunc } from './shared/util/EventEmitter';
import { Factory } from './Factory';
import { UtilFactory } from './shared/util/UtilFactory';
import { PlatformUtil } from './shared/util/PlatformUtil';
import { DevicePerformanceClassifier, DeviceCapability } from './shared/util/DevicePerformanceClassifier';
import { HttpClient } from './http/HttpClient';
import { Builder, HttpRequest, Method, KeyValuePair } from './http/HttpRequest';
import { LoggerLevel, Logger } from './logger/Logger';
import { LocalStorage } from './storage/internal/LocalStorageProvider';
import { KeyValueStore } from './storage/KeyValueStore';
import { HttpResponse, HttpResponseType } from './http/HttpResponse';
import { ErrorCodes } from './error/ErrorCodes';
import { Error, createError, isError, getHexErrorCode } from './error/Error';
import { HttpHeaders } from './http/HttpHeaders';
import Deferred from './shared/util/DeferredUtil';
import AsyncUtil from './shared/util/AsyncUtil';
import RetryUtil from './shared/util/RetryUtil';
import { createSafeTimeout, TimeoutController } from './shared/util/SafeTimeoutUtil';
import CryptoJS from 'crypto-js';
import { HttpServerSentEventClient } from './http/HttpServerSentEventClient';
import { SpeedAnalyser } from './speedtest/SpeedAnalyser';

// ✅ direct re-export instead of import + export
export { SpeedTestProgressListener, QualityURLSet, SpeedTestResult } from './speedtest/SpeedTestProgressListener';
export { TransferStats, DownloadStats, DownloadTestResult } from './speedtest/internal/model/DownloadTestResult';
export { SpeedAnalyserErrorCodes } from './speedtest/internal/SpeedAnalyserErrorCodes';
export { SpeedAnalyser } from './speedtest/SpeedAnalyser';
export * from './shared/util/JSONWebToken';

// --- Factory helpers ---
const createHttpClient = <RequestBody, ResponseBody>(): HttpClient<RequestBody, ResponseBody> =>
  Factory.createHttpClient<RequestBody, ResponseBody>();

const createRequestBuilder = <RequestBody>(): Builder<RequestBody> => Factory.createRequestBuilder<RequestBody>();

const createLogger = (logLevel?: LoggerLevel, tag?: string): Logger => Factory.createlogger(logLevel, tag);

const createKeyValueStore = <T>(storeName: string, localStorage: LocalStorage): KeyValueStore<T> =>
  Factory.createKeyValueStore(storeName, localStorage);

const createEventEmitter = (obj?: any): EventEmitter => UtilFactory.createEventEmitter(obj);

const createHttpServerSentEventClient = (httpURL: string, initData?: EventSourceInit): HttpServerSentEventClient =>
  Factory.createHttpServerSentEventClient(httpURL, initData);

const createSpeedAnalyser = (): SpeedAnalyser => Factory.createSpeedAnalyser();

const version = '__buildVersion__';

export {
  ErrorCodes,
  Error,
  createError,
  isError,
  getHexErrorCode,
  EventEmitter,
  EventSubscribeable,
  Logger,
  Builder,
  Method,
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpResponseType,
  HttpHeaders,
  KeyValueStore,
  Deferred,
  AsyncUtil,
  RetryUtil,
  createHttpClient,
  createRequestBuilder,
  createLogger,
  createKeyValueStore,
  LocalStorage,
  createEventEmitter,
  eventObject,
  AnyFunc,
  CryptoJS,
  LoggerLevel,
  PlatformUtil,
  DevicePerformanceClassifier,
  DeviceCapability,
  KeyValuePair,
  UtilFactory,
  createSafeTimeout,
  TimeoutController,
  version,
  createHttpServerSentEventClient,
  HttpServerSentEventClient,
  // Speed Test Module exports,
  createSpeedAnalyser,
};
